<template>
  <v-app>
    <NavBar v-if="showNavbar" />
    <v-main app>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import { useAuthStore } from "./stores/authStore";
import { onMounted, ref, watch, onUnmounted, provide } from "vue"; // Añadimos onUnmounted
import { useRoute, useRouter } from "vue-router"; // Añadimos useRouter
import confetti from "canvas-confetti"; // Importamos confetti

export default {
  components: {
    NavBar,
  },
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const router = useRouter(); // Necesario para redirigir
    const showNavbar = ref(true);
    const hasSeenIncidenciasPopup = ref(false);

    provide("hasSeenIncidenciasPopup", hasSeenIncidenciasPopup);

    // Función para actualizar la visibilidad de la Navbar
    const updateNavbarVisibility = () => {
      if (
        route.name === "Control" ||
        route.name === "Login" ||
        route.name === "Public" ||
        route.name === "alm_assistant"
      ) {
        showNavbar.value = false;
      } else {
        showNavbar.value = true;
      }
    };

    onMounted(() => {
      authStore.checkAuthentication();
      updateNavbarVisibility();
    });

    // Verificar cambios en la ruta y actualizar la visibilidad de la Navbar
    watch(
      () => route.name,
      () => {
        updateNavbarVisibility();
      }
    );
    //Easter Egg: Konami Code
    const inputSequence = [];
    const secretCode = [
      "ArrowUp",
      "ArrowUp",
      "ArrowDown",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "ArrowLeft",
      "ArrowRight",
      "b",
      "a",
    ];

    const handleKeyDown = (e) => {
      inputSequence.push(e.key);
      if (inputSequence.length > secretCode.length) {
        inputSequence.shift(); // Mantener el array del tamaño correcto
      }

      if (JSON.stringify(inputSequence) === JSON.stringify(secretCode)) {
        triggerSecret();
      }
    };

    const triggerSecret = () => {
      if (window.$toast) {
        window.$toast.success("¡Modo Secreto Activado! 🦖");
      } else {
        alert("¡Modo Secreto Activado! 🦖");
      }

      confetti({
        particleCount: 150,
        spread: 90,
        origin: { y: 0.6 },
      });

      setTimeout(() => {
        router.push("/secret");
      }, 2000); // Espera 2 segundos antes de redirigir
    };

    onMounted(() => {
      window.addEventListener("keydown", handleKeyDown);
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", handleKeyDown);
    });

    return {
      showNavbar,
    };
  },
};
</script>
